import { mapValues, pickBy, isArray } from 'lodash';
/**
 * Normalizes form state to ensure that all values are scalar, or arrays of scalar under their named key.
 * This is important for things like React select which uses Select options as outputs (from onChange) and input props.
 */
var mapValue = function (value) {
  // we have a select option, or some other complex value which has a value prop instead of being scalar
  if (value && value.value) {
    return value.value;
  }
  return value;
};
export var normalizeFormState = function (state) {
  return pickBy(mapValues(state, function (value) {
    if (isArray(value)) {
      return value.map(mapValue);
    }
    return mapValue(value);
  }));
};